import type { IApiKey } from "@/features/tokens/types/token.types";
import type { ApiKey } from "@/features/auth/types/hashKeys.types";
import { ApiKeyCard } from "./ApiKeyCard";
import { getMonitoringTypeFromToken } from "@/constants/monitoring";

interface ApiKeyGridProps {
  allApiKeys: IApiKey[];
  currentApiKeys: ApiKey[];
  selectedApiKeys: string[];
  keysToRemove: string[];
  isPending: boolean;
  isHashKeyActive: boolean;
  onToggle: (apiKeyId: string, isAlreadyDistributed: boolean) => void;
}

export function ApiKeyGrid({
  allApiKeys,
  currentApiKeys,
  selectedApiKeys,
  keysToRemove,
  isPending,
  isHashKeyActive,
  onToggle,
}: ApiKeyGridProps) {
  const currentApiKeyIds = currentApiKeys.map((key) => key.api_key_id);

  return (
    <div className="grid w-full grid-cols-1 justify-center gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
      {allApiKeys.map((apiKey) => {
        const isAlreadyDistributed = currentApiKeyIds.includes(
          apiKey.api_key_id,
        );
        const isNewlySelected = selectedApiKeys.includes(apiKey.api_key_id);
        const isMarkedForRemoval = keysToRemove.includes(apiKey.api_key_id);

        const monitoringType = getMonitoringTypeFromToken(
          apiKey.api_key_preview,
        );
        const isPremium =
          apiKey.api_key_preview?.toLowerCase()?.includes("premium") || false;

        const isChecked =
          (isAlreadyDistributed && !isMarkedForRemoval) || isNewlySelected;
        const isHighlighted = isNewlySelected || isMarkedForRemoval;

        return (
          <ApiKeyCard
            key={apiKey.api_key_id}
            apiKeyPreview={apiKey.api_key_preview}
            monitoringType={monitoringType}
            isPremium={isPremium}
            isChecked={isChecked}
            isHighlighted={isHighlighted}
            isDisabled={isPending || !isHashKeyActive}
            onToggle={() => onToggle(apiKey.api_key_id, isAlreadyDistributed)}
          />
        );
      })}
    </div>
  );
}
